import React from "react";
import { Button, Modal, Notification } from "@telia/teddy";

interface DeleteDraftOrderModalProps {
    isDeleting: boolean;
    error?: string;
    onClose: () => void;
    onConfirm: () => void;
}

const DeleteDraftOrderModal: React.FC<DeleteDraftOrderModalProps> = ({ isDeleting, error, onClose, onConfirm }) => {
    return (
        <Modal open onOpenChange={() => onClose()}>
            <Modal.Overlay>
                <Modal.Content>
                    <Modal.Group variant="title">
                        <Modal.Title as="h3">Slette ordreutkast?</Modal.Title>
                        <Modal.Close aria-label="lukk" slot="floating" onClick={onClose} />
                    </Modal.Group>
                    Er du sikker på at du vil slette dette ordreutkastet? Denne handlingen kan ikke angres.
                    {error && (
                        <Notification type="tile" variant="error">
                            <Notification.Icon />
                            <Notification.Text>{error}</Notification.Text>
                        </Notification>
                    )}
                    <Modal.Group variant="action">
                        <Modal.Close slot="content">
                            <Button variant="secondary" onClick={onClose} disabled={isDeleting}>
                                Avbryt
                            </Button>
                        </Modal.Close>
                        <Button variant="primary" onClick={onConfirm} loading={isDeleting}>
                            Slett
                        </Button>
                    </Modal.Group>
                </Modal.Content>
            </Modal.Overlay>
        </Modal>
    );
};

export default DeleteDraftOrderModal;
